import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class EventRoute extends Route {
  @service eventData;
  @service websocket;
  @service cloudAjax;

  model(params) {
    const eventUuid = params.event_uuid;

    console.log(`[EventRoute] Loading event ${eventUuid}`);

    // Initialize event data structure immediately (so template can render loading state)
    if (!this.eventData.events.has(eventUuid)) {
      this.eventData.events.set(eventUuid, this.eventData.createEventDataStructure(eventUuid));
    }

    // Load data asynchronously - don't block route transition
    this.loadEventDataAsync(eventUuid);

    // Capture service references for use in getters
    const eventDataService = this.eventData;

    // Return immediately so route transitions right away
    return {
      eventUuid,
      get classGroups() {
        return eventDataService.getClassGroups(eventUuid);
      },
      get eventDataObj() {
        return eventDataService.getEventData(eventUuid);
      }
    };
  }

  async loadEventDataAsync(eventUuid) {
    // Subscribe to WebSocket for real-time updates
    try {
      console.log(`[EventRoute] Connecting to WebSocket for event ${eventUuid}...`);
      await this.eventData.subscribeToEvent(eventUuid);
      console.log(`[EventRoute] WebSocket connected for event ${eventUuid}`);
    } catch (error) {
      console.error(`[EventRoute] WebSocket connection failed:`, error);
    }

    // Fetch reference and timing data via REST
    try {
      console.log(`[EventRoute] Fetching initial data for event ${eventUuid}...`);
      const [referenceData, timingData] = await Promise.all([
        this.cloudAjax.getEventReference(eventUuid),
        this.cloudAjax.getEventTiming(eventUuid)
      ]);

      // Load data into event-data service
      this.eventData.loadReferenceData(eventUuid, referenceData);
      this.eventData.loadTimingData(eventUuid, timingData);

      console.log(`[EventRoute] Initial data loaded for event ${eventUuid}`);
    } catch (error) {
      console.error(`[EventRoute] Error fetching initial data:`, error);
    }
  }

  // Note: Message processing is now handled directly by websocket.js calling eventData.processMessage()
}
